import React, { Component, useState, useEffect, useRef } from 'react';
import {
  WingBlank,
  Tag,
  Card,
  List,
  Checkbox,
  Button,
  TextareaItem,
  Toast,
  Modal,
} from 'antd-mobile';
import { info as judges } from '@/services/saas/ratingJudge';
import { detail as getResult, submit } from '@/services/saas/ratingResult';
import { info as activity } from '@/services/saas/ratingActivity';
import { scoringInfo } from '@/services/saas/ratingTemplate';
import { detail as getUserDetail } from '@/services/saas/user';
import { getUser } from '../../utils';
import _ from 'lodash';
import '@/styles/judge.scss';
import './index.scss';
import defaultImg from '@/images/header_type2.jpg';

const CheckboxItem = Checkbox.CheckboxItem;

const RatingCard = (props) => {
  const { data = [], title, value = [], type, disabled, onChange } = props;

  let score = 0;
  let names = [];
  if (value) {
    let temp = value;
    if (type === 1) {
      temp = [temp];
    }
    data
      .filter((item) => temp.indexOf(item.itemId) > -1)
      .forEach((item) => (score = item.itemScore * 1 + score));
    data
      .filter((item) => temp.indexOf(item.itemId) > -1)
      .forEach((item) => names.push(item.itemCode));
  }

  const handleChange = (itemId, checked) => {
    if (type === '1') {
      if (onChange) onChange([itemId]);
    } else {
      let temp = [];
      if (checked) {
        const index = value.findIndex((item) => item === itemId);
        if (index === -1) {
          temp = [...value, itemId];
        }
      } else {
        temp = value.filter((item) => item !== itemId);
      }
      if (onChange) onChange(temp);
    }
  };

  return (
    <Card className={`${type !== '1' ? 'checkbox-mode' : ''}`}>
      <Card.Header
        title={
          <div className={`card-header ${disabled ? 'disabled' : ''}`}>
            <div className="card-header-title">{title}</div>
            <div className="card-header-tag">
              <Tag small>{type === '1' ? '单选' : '多选'}</Tag>
            </div>
          </div>
        }
      />
      <Card.Body>
        {data.map((item) => {
          return (
            <CheckboxItem
              key={item.itemId}
              disabled={disabled}
              checked={value.indexOf(item.itemId) > -1}
              onChange={(obj) => handleChange(item.itemId, obj.target.checked)}
            >
              <div className={`card-body`}>
                <label className="card-body-title">{`${item.itemCode}  ${item.itemContent}`}</label>
                <span className="card-body-tag">{`${item.itemScore}分`}</span>
              </div>
            </CheckboxItem>
          );
        })}
      </Card.Body>
      <Card.Footer
        content={
          names.length > 0 && (
            <div>
              <label style={{ marginRight: '5px' }}>已选:</label>
              <span>
                {names.map((item) => (
                  <Tag small key={item}>
                    {item}
                  </Tag>
                ))}
              </span>
            </div>
          )
        }
        extra={<div>分数:{score}</div>}
      />
    </Card>
  );
};

const RatingCol = (props) => {
  const { title, data = [], value = {}, disabled, onChange } = props;

  const handleChange = (detailId, newValue) => {
    const temp = { ...value };
    temp[detailId] = newValue;
    if (onChange) onChange(temp);
  };

  return (
    <>
      <div className="rating-list">
        <WingBlank size="lg">
          <List renderHeader={() => title}>
            {data.map((item, index) => {
              const _detailId = item.detailId;
              const _target = item.target;
              return (
                <RatingCard
                  key={_target.targetId}
                  type={_target.targetType}
                  data={_target.targetItemList}
                  value={value[_detailId]}
                  title={`${index + 1}.${_target.targetTitle}`}
                  onChange={(value) => handleChange(_detailId, value)}
                  disabled={disabled}
                />
              );
            })}
          </List>
        </WingBlank>
      </div>
    </>
  );
};

const RatingScore = (props) => {
  const { id, userId, disabled = false, style } = props;

  const [value, setValue] = useState({});

  const [evaluate, setEvaluate] = useState(undefined);

  const [data, setData] = useState({});

  const [result, setResult] = useState({});

  const [items, setItems] = useState({});

  const [user, setUser] = useState({});

  const [templateId, setTemplateId] = useState(undefined);

  const [theDisabled, setTheDisabled] = useState(false);

  const valueRef = useRef({});

  const getDetail = async (id, userId) => {
    const resp = await activity({ bizId: id, bizType: 'conference' });
    if (!resp || !resp.success) {
      return;
    }
    const { ratingTemplateId } = resp.data;
    if (ratingTemplateId) {
      const userResp = await getUserDetail({ id: userId });
      if (!userResp) {
        return;
      }
      const scorResp = await scoringInfo({ templateId: ratingTemplateId });
      if (!scorResp || !scorResp.success || JSON.stringify(scorResp.data) === '{}') {
        return;
      }

      const items = [];
      const defaultValue = {};
      const { columnList } = scorResp.data;
      columnList.forEach((item) => {
        const { columnDetailList } = item;
        const obj = {};
        columnDetailList.forEach((v) => {
          const {
            target: { targetItemList },
          } = v;
          targetItemList.forEach((vv) => {
            items[vv.itemId] = vv.itemScore;
          });
          obj[v.detailId] = [];
        });
        defaultValue[item.columnId] = obj;
      });
      setItems(items);
      setUser(userResp.data);
      setData(scorResp.data);
      setValue(defaultValue);
      setTemplateId(ratingTemplateId);
    }
  };

  const getRatingResult = async (bizId, userId) => {
    const bizType = 'conference';
    const resp = await getResult({ bizId, bizType, userId });
    if (!resp || !resp.success) {
      return;
    }
    if (resp.data) {
      const obj = {};
      const { detailList, isSubmit, evaluate } = resp.data;
      if (detailList) {
        detailList.forEach((item) => {
          const { columnId } = item;
          if (obj[columnId]) {
            obj[columnId][item.columnDetailId] = item.itemIds.split(',');
          } else {
            obj[columnId] = {
              [item.columnDetailId]: item.itemIds.split(','),
            };
          }
        });
        setValue(obj);
        setEvaluate(evaluate);
        setTheDisabled(isSubmit === '1');
        setResult(resp.data);
      }
    }
  };

  const save = async (param) => {
    let value = valueRef.current.value,
      result = valueRef.current.result,
      templateId = valueRef.current.templateId,
      evaluate = valueRef.current.evaluate;
    const defaultParam = {
      bizId: id,
      bizType: 'conference',
      templateId,
    };
    const detailList = [];
    Object.keys(value).forEach((item) => {
      Object.keys(value[item]).forEach((columnDetailId) => {
        const itemIds = value[item][columnDetailId];
        if (itemIds.length === 0) {
          Toast.fail('有评分尚未选择');
          // eslint-disable-next-line no-throw-literal
          throw '有评分尚未选择';
        }
        detailList.push({
          itemIds: itemIds.join(','),
          columnDetailId,
        });
      });
    });

    const { resultId } = result;
    const obj = { ...defaultParam, ...param, detailList, resultId, evaluate };
    if (param.isSubmit === '1') {
      Modal.alert('确定提交', '提交后无法修改,确定提交?', [
        { text: '取消', onPress: () => {} },
        {
          text: '确定',
          onPress: async () => {
            const resp = await submit(obj);
            if (resp && resp.success) {
              Toast.success('提交成功');
              getRatingResult(id, userId);
            }
          },
        },
      ]);
    } else {
      const resp = await submit(obj);
      if (resp && resp.success) {
        Toast.success('保存成功');
        getRatingResult(id, userId);
      }
    }
  };

  const getDefault = async (id, userId) => {
    // 查询详情
    await getDetail(id, userId);
    // 查询评分结果
    getRatingResult(id, userId);
  };

  useEffect(() => {
    if (id && userId) {
      // 查询详情
      getDefault(id, userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, userId]);

  useEffect(() => {
    valueRef.current.value = value;
    valueRef.current.result = result;
    valueRef.current.templateId = templateId;
    valueRef.current.evaluate = evaluate;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, result, templateId, evaluate]);

  const handleChange = (columnId, values) => {
    const temp = { ...value };
    temp[columnId] = { ...temp[columnId], ...values };
    console.log(temp);
    setValue(temp);
  };

  const getSum = () => {
    let number = 0;
    Object.keys(value).forEach((item) => {
      Object.keys(value[item]).forEach((key) => {
        const temp = value[item][key];
        temp.forEach((id) => {
          number += items[id] ? items[id] : 0;
        });
      });
    });
    return number;
  };

  const saveClick = useRef(
    _.debounce((value) => {
      save(value);
    }, 500),
  ).current;

  return (
    <div style={style}>
      {(data.columnList || []).map((item) => (
        <RatingCol
          key={item.columnId}
          id={item.columnId}
          title={item.columnName}
          data={item.columnDetailList}
          value={value[item.columnId]}
          onChange={(values) => handleChange(item.columnId, values)}
          disabled={theDisabled || disabled}
        />
      ))}
      <div style={{ marginBottom: '10px' }}>
        <WingBlank size="lg">
          <Card>
            <Card.Header
              title={
                <div className={`card-header ${theDisabled || disabled ? 'disabled' : ''}`}>
                  <div className="card-header-title">评价</div>
                </div>
              }
            />
            <Card.Body>
              <TextareaItem
                style={{ fontSize: '15px' }}
                value={evaluate}
                onChange={setEvaluate}
                rows={3}
                placeholder="请输入评价"
                disabled={theDisabled}
              />
            </Card.Body>
          </Card>
        </WingBlank>
      </div>
      <div className="rating-infor-wrapper" style={{ marginBottom: '10px' }}>
        <WingBlank size="lg">
          <Card>
            <Card.Body>
              <div className={`rating-infor  ${theDisabled || disabled ? 'disabled' : ''}`}>
                <div>评委: {user && user.name}</div>
                <div>总分: {getSum()}</div>
              </div>
            </Card.Body>
          </Card>
        </WingBlank>
      </div>
      <div className="rating-button">
        <WingBlank size="lg">
          <Button onClick={() => saveClick({ isSubmit: '0' })} disabled={theDisabled}>
            保存
          </Button>
          <Button
            onClick={() => saveClick({ isSubmit: '1' })}
            type="primary"
            disabled={theDisabled}
          >
            提交
          </Button>
        </WingBlank>
      </div>
    </div>
  );
};

const JudgeList = (props) => {
  const { data = [], style } = props;
  return (
    <div style={style} className="member-card">
      <div className="member-card-rapper">
        {data.map((item) => (
          <div key={item.id} className="item">
            <img className="image" src={item.avatar || defaultImg} alt="cover" />
            <div className="label">{item.userName}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

class Judge extends Component {
  state = {
    tabList: [
      { id: 'ratingList', name: '评分' },
      { id: 'judgeList', name: '评委' },
    ],
    selectedId: 'ratingList',
    judgesData: [],
  };

  componentDidMount() {
    this.default();
  }

  default = () => {
    // 获取评委列表
    this.getJudgeList();
  };

  getJudgeList = async () => {
    const { id: bizId } = this.props;
    if (bizId) {
      const resp = await judges({ bizId, bizType: 'conference' });
      if (resp && resp.success) {
        const judgesData = resp.data;
        this.setState({ judgesData });
      }
    }
  };

  onTabChange = (selectedId) => {
    this.setState({
      selectedId,
    });
  };

  render() {
    const { tabList, selectedId, judgesData } = this.state;
    const { id } = this.props;
    const { userId } = getUser() || {};
    return (
      <div className="judge">
        <div className="tab">
          {tabList.map((item) => (
            <span
              key={item.id}
              className={`item ${selectedId === item.id ? ' on' : ''}`}
              onClick={() => this.onTabChange(item.id)}
            >
              {item.name}
              <span style={{ color: '#91f891' }}>
                {item.id === 'judgeList' ? `(${judgesData.length})` : null}
              </span>
            </span>
          ))}
        </div>
        <div className="tab-panel">
          <RatingScore
            style={selectedId === 'ratingList' ? {} : { display: 'none' }}
            id={id}
            userId={userId}
          />
          <JudgeList
            style={selectedId === 'judgeList' ? {} : { display: 'none' }}
            data={judgesData}
          />
        </div>
      </div>
    );
  }
}
export default Judge;
